import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { map } from 'rxjs/internal/operators/map';
import { ErrorCode } from '../constants/error-code';

const routes = {
  getPdf: `/verify-account/file-provision`,
  identifyProvision: '/anonymous/customer/file-enterprise-provision',
  signSimCANoImage: () => '/verify-account/sign-sim-ca',
  signSimCAImage: () => '/verify-account/sign-sim-ca',
  createHashWithImage: () => `/verify-account/generate-hash`,
  createHashNoImage: () => `/verify-account/generate-hash`,
  signCloudCa: () => '/verify-account/sign-cloud-ca',
  signUsb: () => `/verify-account/sign-usb-token`,
  confirmKyc: () => `/verify-account/ekyc`,
  verifyAndUpdate:() =>`/verify-account/verify-and-update`
};

@Injectable({
  providedIn: 'root'
})
export class KycService {
  constructor(
    private apiService: ApiService
  ) { }

  // check error
  checkErrorVerifyAccountGetPdf() {
    return this.apiService.get(routes.getPdf)
      .pipe(map(res => {
        return res;
      }));
  }

  // View pdf
  verifyAccountGetPdf() {
    return this.apiService.getFile(routes.getPdf)
      .pipe(map(res => {
        return res;
      }));
  }

  //xem pdf với các trường được thay đổi
  verifyNewAccountGetPdf(payload) {
    return this.apiService.getFilePostMethod(routes.getPdf,{...payload})
      .pipe(map(res => {
        return res;
      }));
  }

  verifyCustomerGetPdf(body) {
    return this.apiService.getFilePostMethod(routes.identifyProvision, body)
      .pipe(map(res => {
        return res;
      }));
  }

  signSimCANoImage(sign) {
    return this.apiService.post(routes.signSimCANoImage(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  signSimCAImage(sign) {
    return this.apiService.post(routes.signSimCAImage(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  signCloudCa(sign) {
    return this.apiService.post(routes.signCloudCa(), sign)
      .pipe(map(res => {
        return res;
      }))
  }

  createHashWithImage(hash: any) {
    return this.apiService.post(routes.createHashWithImage(), hash)
      .pipe(map(res => {
        return res;
      }));
  }

  createHashNoImage(hash: any) {
    return this.apiService.post(routes.createHashNoImage(), hash)
      .pipe(map(res => {
        console.log(res);
        return res;
      }));
  }

  signUsb(certificate: any) {
    return this.apiService.post(routes.signUsb(), certificate)
      .pipe(map(res => {
        return res;
      }));
  }

  confirmKyc(data: any) {
    return this.apiService.post(routes.confirmKyc(), data)
      .pipe(map(res => {
        return res;
      }));
  }

  verifyAndUpdate(data:any){
    return this.apiService.post(routes.verifyAndUpdate(), data)
      .pipe(map(res => {
        return res;
      }));
  }

}
